import { setCurrentLocation } from 'src/store/Reducer/socket/currentLocationSlice'
import { useEffect } from 'react'
import { setWifiInfo } from 'src/store/Reducer/socket/WifiSlice'
import { setSoundPlayStatus } from 'src/store/Reducer/page/locationPageSlice'
import { setLocationInfos } from 'src/store/Reducer/socket/LocationHistorySlice'
import { Cmdtypes } from 'src/constants/cmdtypes'
import { useAppDispatch } from 'src/hooks/redux/useAppDispatch'
import { Errcode } from 'src/constants/errcode'

import { ResponseDataBody, ResponseDataType } from 'src/types/websocket'
import { eventBus } from 'src/api/eventBus'
import { useLocation } from 'react-router-dom'

const useLocationEventBus = () => {
  const dispatch = useAppDispatch()
  const { pathname } = useLocation()
  useEffect(() => {
    const SirenStartResponseListener = eventBus.subscribe<unknown>(
      Cmdtypes.SIREN_START,
      handleSirenStartResponse,
    )
    const CurrentLocationResponseListener = eventBus.subscribe<ResponseDataBody.CurrentLocation>(
      Cmdtypes.CURRENT_LOCATION_INFO,
      handleCurrentLocationResponse,
    )
    const LocationListResponseListener = eventBus.subscribe<ResponseDataBody.LocationHistory>(
      Cmdtypes.LOCATION_INFO,
      handleLocationListResponse,
    )
    const WifiListResponseListener = eventBus.subscribe<ResponseDataBody.WifiList>(
      Cmdtypes.WIFI_LIST,
      handleWifiListResponse,
    )
    return () => {
      SirenStartResponseListener.unsubscribe()
      CurrentLocationResponseListener.unsubscribe()
      LocationListResponseListener.unsubscribe()
      WifiListResponseListener.unsubscribe()
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [pathname])

  const handleSirenStartResponse = (message: ResponseDataType<unknown>) => {
    const { Header } = message.responseData
    if (Header.ErrCode === Errcode.SUCCESS) {
      dispatch(setSoundPlayStatus(false))
    } else console.error(Header)
  }

  const handleCurrentLocationResponse = (
    message: ResponseDataType<ResponseDataBody.CurrentLocation>,
  ) => {
    const { Header, Body } = message.responseData
    if (Header.ErrCode === Errcode.SUCCESS) {
      dispatch(setCurrentLocation(Body))
    } else console.error(Header)
  }

  const handleLocationListResponse = (
    message: ResponseDataType<ResponseDataBody.LocationHistory>,
  ) => {
    const { Header, Body } = message.responseData
    if (Header.ErrCode === Errcode.SUCCESS) {
      dispatch(setLocationInfos(Body))
    } else console.error(Header)
  }

  const handleWifiListResponse = (message: ResponseDataType<ResponseDataBody.WifiList>) => {
    const { Header, Body } = message.responseData
    if (Header.ErrCode === Errcode.SUCCESS) {
      dispatch(setWifiInfo(Body))
    } else console.error(Header)
  }
}
export default useLocationEventBus
